<template>
    <button type="button" class="btn" v-bind:class="[btnAllClasses]" :disabled="busy || disabled" @click="callback($event)">
        <span v-if="failed && !busy" class="" v-bind:class="{ 'btn-labeled btn-labeled-left' : icon }" style="pointer-events: none;"><b v-if="icon"><i class="icon-cross2"></i></b> {{ errorText }}</span>
        <span v-else-if="saved && !busy" class="" v-bind:class="{ 'btn-labeled btn-labeled-left' : icon }" style="pointer-events: none;"><b v-if="icon"><i class="icon-checkmark4"></i></b>{{ savedText }}</span>
        <span v-else-if="icon" class="btn-labeled btn-labeled-left" style="pointer-events: none;"><b><i v-bind:class="[busy ? ['icon-spinner2','spinner'] : icon ]"></i></b><slot></slot></span>
        <span v-else style="pointer-events: none;"><div v-if="busy" style="position: absolute; left: 0; right: 0;"><i class="icon-spinner2 spinner"></i></div><div v-bind:style="{ 'opacity': (busy ? 0 : 1) }"><slot></slot></div></span>
    </button>
</template>

<script>
export default {
    name: 'LimitlessButton',
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        btnClass: {
            type: String,
            default: 'btn-primary',
        },
        icon: {
            type: String,
            default: '',
        },
        savedText: {
            type: String,
            default: 'SPARAD!',
        },
        errorText: {
            type: String,
            default: 'ERROR!',
        },
    },
    data: () => ({
        saved: false,
        failed: false,
    }),
    methods: {
        triggerSaved() {
            this.saved = true;
            this.failed = false;
            setTimeout(() => { this.saved = false; }, 2000);
        },
        triggerFailed() {
            this.failed = true;
            this.saved = false;
            setTimeout(() => { this.failed = false; }, 2000);
        },
        resetState() {
            this.failed = false;
            this.saved = false;
        },
        callback(e) {
            this.$emit('click', e);
        },
    },
    computed: {
        btnTypeClass() {
            if (this.failed) {
                return 'btn-danger';
            } if (this.saved) {
                return 'btn-success';
            }
            return this.btnClass;
        },
        btnAllClasses() {
            if (this.failed) {
                return `btn-danger ${this.btnTypeClass}${this.icon ? ' pl-0' : ''}`;
            } if (this.saved) {
                return `btn-success ${this.btnTypeClass}${this.icon ? ' pl-0' : ''}`;
            }
            return `${this.btnTypeClass} ${this.icon ? ' pl-0' : ''}`;
        },
    },
};
</script>

<style scoped>
.btn-sm > .btn-labeled > b {
    padding: 0.5rem;
}
.btn-sm > .btn-labeled-left {
    padding-left: 2.75rem;
}
</style>
